import { useState } from "react";
import axios from "axios";
import { copiaDoFicheiro } from "../../../lib/copiaDoFicheiro";
import { mensagemDeErro } from "../../../lib/erroApi";
import { toast } from "sonner";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../../../components/ui/dialog";
import { API } from "../../../App";

export default function PilotsImportDialog({ onClose, onImported }) {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const send = async (commit) => {
    if (!file) { setError("Escolhe um ficheiro CSV."); return; }
    setError(""); setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", await copiaDoFicheiro(file));
      fd.append("commit", commit ? "true" : "false");
      const r = await axios.post(`${API}/di/pilots/import`, fd, { withCredentials: true });
      setPreview(r.data);
      if (r.data.committed) { toast.success(`Importados ${r.data.inserted} pilotos`); onImported(); }
    } catch (e) { setError(mensagemDeErro(e, "Erro a importar")); }
    finally { setLoading(false); }
  };

  const canCommit = preview && preview.preview.valid_rows > 0 && preview.preview.errors.length === 0 && !preview.committed;

  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="bg-slate-900 border-slate-700 max-w-2xl" data-testid="di-pilots-import-dialog">
        <DialogHeader>
          <DialogTitle className="text-white">Importar pilotos (CSV)</DialogTitle>
          <DialogDescription className="text-slate-400">Cabeçalhos obrigatórios: <code>name, pu_number</code>. Opcionais: <code>license_type, pu_license_valid_until, medical_cert_number, medical_valid_until, notes</code>.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 text-xs">
          <Input type="file" accept=".csv,text/csv" onChange={(e) => { setFile(e.target.files?.[0] || null); setPreview(null); }} className="bg-slate-800 border-slate-700" data-testid="di-pilots-import-file" />
          <div className="flex gap-2">
            <Button variant="outline" size="sm" onClick={() => send(false)} disabled={!file || loading} data-testid="di-pilots-import-preview-btn">Pré-visualizar</Button>
            <Button size="sm" onClick={() => send(true)} disabled={!canCommit || loading} data-testid="di-pilots-import-commit-btn">Confirmar importação</Button>
          </div>
          {error && <div className="text-red-400">{error}</div>}
          {preview && (
            <div className="border border-cockpit-border rounded p-3 bg-slate-900/50">
              <div className="text-slate-300">✓ {preview.preview.valid_rows} linhas válidas{preview.preview.errors.length > 0 && <span className="ml-2 text-red-400">✗ {preview.preview.errors.length} erros</span>}</div>
              {preview.preview.errors.length > 0 && <div className="mt-2 max-h-40 overflow-auto"><table className="w-full text-[11px]"><thead className="text-slate-500"><tr><th className="text-left">Linha</th><th className="text-left">Erro</th></tr></thead><tbody>{preview.preview.errors.slice(0, 20).map((e, i) => <tr key={i} className="text-red-300"><td className="font-mono">{e.line}</td><td>{e.error}</td></tr>)}</tbody></table></div>}
              {preview.preview.sample.length > 0 && <details className="mt-2"><summary className="cursor-pointer text-slate-400">Pré-visualizar ({Math.min(5, preview.preview.sample.length)} primeiras)</summary><div className="mt-1 max-h-40 overflow-auto font-mono text-[10px]">{preview.preview.sample.map((r, i) => <div key={i} className="text-slate-300 truncate">{r.name} · {r.license_type} {r.pu_number} · médico {r.medical_valid_until || "—"}</div>)}</div></details>}
              {preview.committed && <div className="mt-2 text-emerald-300">✓ Importados {preview.inserted} pilotos.</div>}
            </div>
          )}
        </div>
        <DialogFooter><Button variant="ghost" onClick={onClose}>Fechar</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
